export type Image = {
  id: string
  url?: string | null
  kind: string
}

export type GalleryImage = Image & {
  url: string
}

export type VenueImageGalleryProps = {
  images: Image[]
}

export const isVenuePhotoWithUrl = (image: Image): image is GalleryImage =>
  image.kind === "venue_photo" && typeof image.url === "string" && image.url.trim().length > 0

export const getVenuePhotoAlt = (index: number) => `Venue photo ${index + 1}`

export const getOpenVenuePhotoLabel = (index: number) => `Open venue photo ${index + 1}`
